<template>
  <div>
    <base-dialog :show="!!error" title="An error occurred" @close="handleError">
      <p>{{ error }}</p>
    </base-dialog>
    <base-dialog :show="isLoading" :title="submitButtonCaption" fixed>
      <base-spinner></base-spinner>
    </base-dialog>
    <base-card>

      <div class="logo-field">
        <router-link to="/"><main-logo /></router-link>
      </div>

      
        <div class="login-title">아이디 찾기</div>  
        <div class="sub_description">사용하시는 닉네임을 입력해 주세요</div>      
      

      <fieldset>
        <legend>비밀번호 재설정</legend>
        <div class="login_set">

          <dl id="login-field" class="input_list">
           
              <dt class="display_none" >
                <label for="mb_id">닉네임 입력</label>
              </dt>
              <dd class="dd_mb_id" >
                <input type="text" name="nic" v-model.trim="nic.val"  placeholder="닉네임 입력" autocomplete="off" 
                @blur="clearValidity('nic')"
                @keyup.enter="submitForm2"
                >
              </dd>           
          </dl>

            <div class="findresult" v-if="find">
                <dl>
                    <dt>닉네임 {{resultNic}} 님의 아이디는</dt>
                    <dd class="resultID">{{findID}}</dd>
                    <dd>입니다.</dd>
                </dl>                
            </div>

          <div class="acc">
            <ul>
              <li>
               <router-link to="/auth/reset_pw">비밀번호 재설정</router-link>
                <span class="bar"></span>
              </li>
              <li>
                <router-link to="/auth/login">로그인</router-link>
                <span class="bar"></span>
              </li>
              <li>
                <router-link to="/auth/register">
                  <strong>간편회원가입</strong>
                </router-link>
              </li>
            </ul>
          </div>
          <p v-if="!nic.isValid" class="alert-valid">
            닉네임을 입력해 주세요
          </p>
          
          
          <base-button :mode="switchModeButtonCaption" @click="submitForm2"
          ref="test">{{submitButtonCaption}}</base-button>
         
        </div>
      </fieldset>
      
      <div class="footer">Copyright (c){{ siteName }}. All Rights Reserved.</div>

    </base-card>
  </div>
</template>

<script>
//import * as auth from '@/services/auth_service';

export default {
  props:[
    'prevroute','path'
  ],
  data() {
    return {
      nic: {val:"",isValid:true},    
      mode: "findID",
      isLoading: false,
      error: null,
      find:false,
      findID:'',
      resultNic:''
    };
  },
  computed: {
    siteName(){
      return this.$store.state.siteName;
    },  
    submitButtonCaption() {
      if (this.mode === "findID") {
        return "아이디 찾기";
      } else {
        return "비밀번호 변경";
      }
    },
    switchModeButtonCaption() {
      if (this.mode === "findID") {
        return "skyblue";
      } else {
        return "red";
      }
    },
  },
  methods: {
    validateForm() {
      this.formIsValid = true;
       if(this.nic.val === ""  ) 
        {
          this.email.isValid = false;
          this.formIsValid = false;        
        }           
    },
    async submitForm2() {      
     
      this.validateForm();
      if (!this.formIsValid) {
        return;
      }
      this.isLoading = true;
      const actionPayload = {
        nic: this.nic.val,        
      };

      try {        
       
        const response = await this.$store.dispatch("users/getUserID" , actionPayload);
        console.log(response);
      
        if(response.status_code===200)
        {
            this.find = true;
            this.findID = response.user.email;  
            this.resultNic = this.nic.val;   
            this.nic.val ='';
        }else{
            this.find = false;
        }

        this.$flashMessage.show({
          type: response.status_code===200? "info":"error",
          title: response.message,
          message: response.message,
        });
      } catch (error) {
        console.log(error.response);
        switch (error.response.status) {
          case 422:
            this.$flashMessage.show({
              type: "error",
              title: "유효하지 않은 데이터 입력입니다.",
              message: "유효하지 않은 데이터 입력입니다.",
            });
            break;
          case 401:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });
            break;
          case 500:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });
            break;
          default:
            this.$flashMessage.show({
              type: "error",
              title: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
              message: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
            });
            break;
        }
      }
      this.isLoading = false;
    },   
    clearValidity(input) {
      this[input].isValid = true;
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  margin: 1rem;
  padding: 1rem;
  padding-top:0;
}
.logo-field{
  text-align:center;
  padding:20px 0;
}
.login-title{
  font-weight:bold;
  padding-left:2rem;
  font-size:20px;
  font-family:malgungothic;
}
.sub_description{
  margin-top:10px;
  padding-left:2rem;
  color:#999;
}
fieldset{
  border: 0;
  legend{display:none;}
  font-family:굴림,gulim;
  .login_set{
    .input_list{

        input{
            padding:0 20px;
            height:49px;
            border: 1px solid #dadada;
            font-size: 12px;
            width:100%;
        }
        .email_token input{
          border: 1px solid #b72e00;
        }
        .bt_none input{
            border-top:1px solid #fff !important;
        }

        }
    }
    .findresult{
        margin-top:10px;
        text-align: center;
        background: #eee;
        padding:20px;
        border-radius: 10px;
        .resultID{
            font-size:30px;
            font-weight: bold;
            padding:10px;
            font-family: 'nanumgothic';
        }
    }
    .acc{
        margin:20px 0;
        display:flex;
        justify-content: flex-end;
        font-size:12px;
        color: #999;
        ul{
            display:flex;

            li{
                a{
                    line-height: 19px;
                    color: #999;
                }
                .bar{
                    margin: 4px 10px 0;
                    width: 1px;
                    height: 11px;
                    background-color: #e5e5e5;
                    display: inline-block;
                }
            }
        }
    }
    .alert-valid{
        font-size:12px;
        color:#b72e00;
    }
}
.footer{
    font-size: 10px;
    font-family: Arial,Helvetica,sans-serif;
    text-align: center;
    color: #999;
}


</style>
